import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http } from '@angular/http';
import { AuthenticationService } from 'app/core/index';

@Injectable()
export class FiatService {
  constructor(private http: Http, private auth: AuthenticationService) {}

  public getConvertAmount(currency: string, amount: number) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.post(
      '/api/deposit/fiat/convert',
      {
        currency,
        amount,
      },
      {
        headers: headers,
      }
    );
  }

  public getLimits(currency: string) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.post(
      '/api/deposit/fiat/limits',
      {
        currency,
      },
      {
        headers: headers,
      }
    );
  }

  public createTransactionLink(currency: string, amount: number) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.post(
      '/api/deposit/fiat/create-link',
      {
        currency,
        amount,
      },
      {
        headers: headers,
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/account/fiat.service.ts